import { getDefaultViewState } from '../../helpers/get-default-view-state';
import type { DashboardFilterState, ViewState } from '../../types/dashboard-filter-types';

export function ensureViewExists(
  state: DashboardFilterState,
  viewId: string
): ViewState {
  if (!state.views[viewId]) {
    state.views[viewId] = getDefaultViewState(viewId);
  }
  return state.views[viewId];
}
